import { createSlice } from "@reduxjs/toolkit";

import {
  getPermissionThunk,
  createPermissionThunk,
  updatePermissionThunk,
  deletePermissionThunk,
  bulkCreatePermissionThunk,
} from "state/action/permission";

// Initial state
const initialState = {
  // Get Permission inisial state
  getPermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Permission inisial state
  createPermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  // Update Permission inisial state
  updatePermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  updateDepartmentPermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Permission inisial state
  deletePermission: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createPermissionInputBody: {
    name: "",
    code: "",
    subject: "", // e.g., 'Tenant'
    action: "", // e.g., 'create'
    fields: [], // Array of strings
    conditions: "{}", // Stored as string in UI for editing, parsed later
    inverted: false,
    description: "",
    category: "custom",
    isSystem: false,
    isActive: true,
  },
  selectedPermission: {},
  // Permission object value
  permission_object_value: "",
};

export const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermissionField: (state, action) => {
      const { field, value } = action.payload;
      state.createPermissionInputBody[field] = value;
    },
    setFieldsArray: (state, action) => {
      state.createPermissionInputBody.fields = action.payload;
    },
    resetPermissionForm: (state) => {
      state.createPermissionInputBody = initialState.createPermissionInputBody;
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.createPermissionInputBody[field] = value;
    },
    // Reducer khusus untuk handle array multiselect (roles, depts, types)
    setArrayField: (state, action) => {
      const { field, value } = action.payload;
      state.createPermissionInputBody[field] = value;
    },
    resetForm: (state) => {
      state.createPermissionInputBody = initialState.createPermissionInputBody;
    },
    // Jika mode edit, isi form dengan data yang ada
    populateForm: (state, action) => {
      state.createPermissionInputBody = action.payload;
    },

    // --- Reducers untuk array 'represented_by' ---
    addRepresentative: (state) => {
      state.createPermissionInputBody.represented_by.push({
        name: "",
        title: "",
      });
    },
    updateRepresentative: (state, action) => {
      const { index, field, value } = action.payload;
      state.createPermissionInputBody.represented_by[index][field] = value;
    },
    removeRepresentative: (state, action) => {
      const index = action.payload;
      state.createPermissionInputBody.represented_by.splice(index, 1);
    },

    setGetPermissionObjectValue: (state, action) => {
      return {
        ...state,
        Permission_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetPermissionObjectValue: (state, _) => {
      return {
        ...state,
        Permission_object_value: "",
      };
    },
    setCreatePermissionInputBody: (state, action) => {
      return {
        ...state,
        createPermissionInputBody: action.payload,
      };
    },
    setSelectedPermission: (state, action) => {
      return {
        ...state,
        selectedPermission: action.payload,
      };
    },
    setClearCreatePermissionInputBody: (state, _) => {
      return {
        ...state,
        createPermissionInputBody: {
          name: "",
          email: "",
          description: "",
          directorate: "",
          division: "",
          represented_by: [
            {
              name: "",
              title: "",
            },
          ],
          code: "",
        },
      };
    },
    setClearCreatePermission: (state, _) => {
      return {
        ...state,
        createPermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetPermission: (state, _) => {
      return {
        ...state,
        getPermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdatePermission: (state, _) => {
      return {
        ...state,
        updatePermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeletePermission: (state, _) => {
      return {
        ...state,
        deletePermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllPermissionState: (state, _) => {
      return {
        ...state,
        // Get Permission inisial state
        getPermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Permission inisial state
        createPermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Permission inisial state
        updatePermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Permission inisial state
        deletePermission: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Permission object value
        Permission_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Permission reducer
      .addCase(getPermissionThunk.pending, (state, _) => {
        return {
          ...state,
          getPermission: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPermissionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getPermission: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPermissionThunk.rejected, (state, action) => {
        return {
          ...state,
          getPermission: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Permission reducer
      .addCase(createPermissionThunk.pending, (state, _) => {
        return {
          ...state,
          createPermission: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPermissionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createPermission: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPermissionThunk.rejected, (state, action) => {
        return {
          ...state,
          createPermission: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })

      // Bulk Create Permission reducer
      .addCase(bulkCreatePermissionThunk.pending, (state, _) => {
        return {
          ...state,
          createPermission: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(bulkCreatePermissionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createPermission: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(bulkCreatePermissionThunk.rejected, (state, action) => {
        return {
          ...state,
          createPermission: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })

      // update Permission reducer
      .addCase(updatePermissionThunk.pending, (state, _) => {
        return {
          ...state,
          updatePermission: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePermissionThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updatePermission: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePermissionThunk.rejected, (state, action) => {
        return {
          ...state,
          updatePermission: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const permissionAction = {
  ...permissionSlice.actions,
  getPermissionThunk,
  createPermissionThunk,
  updatePermissionThunk,
  deletePermissionThunk,
  bulkCreatePermissionThunk,
};

export function selectPermissionObjectValue(state) {
  return state?.permission?.permission_object_value;
}

export function selectPermission(state) {
  return state?.permission;
}

export default permissionSlice.reducer;
